import { useEffect, useState } from 'react';

export function useTransitionAnnouncement(message: string) {
  const [finalMessage, setMessage] = useState('');

  useEffect(() => {
    const a11yElement = document.getElementById('a11y-status');
    if (!a11yElement) return void 0;

    const timer = setTimeout(() => {
      setMessage(message);
    }, 150);

    return () => clearTimeout(timer);
  }, [message]);

  return finalMessage;
}
